module.exports = __webpack_public_path__ + "static/media/upload-table-example.7a8c4574.png";